package com.patronat.top.core.domain.models.profiles

import com.patronat.top.dto.UserRole
import com.patronat.top.dto.UserStatus
import kotlinx.datetime.Instant

data class User( val id: String? = null,
                 val phone: String,
                 val email: String?,
                 val firstName: String,
                 val lastName: String,
                 val role: UserRole,
                 val status: UserStatus,
                 val isPhoneVerified: Boolean? = null,
                 val isEmailVerified: Boolean? = null,
                 val createdAt: Instant? = null,
                 val avatarUrl: String? = null,
                 val avatarMediaId: String? = null,)